(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4558],{

/***/ 54286:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/pdf-tools/pdf-to-png",
      function () {
        return __webpack_require__(99538);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CalculatorBlogs_Blog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
;// CONCATENATED MODULE: ./components/CalculatorBlogs/BlogCard.jsx




const BlogCard = (param)=>{
    let { question , answer  } = param;
    const [blogVisible, setBlogVisible] = (0,react.useState)(true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex mb-[30px] pb-[30px] gap-[20px] border-b border-b-gray-300",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: ()=>blogVisible ? setBlogVisible(false) : setBlogVisible(true),
                className: "pt-[5px] text-[20px] md:text-[35px] w-fit cursor-pointer",
                children: blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineMinus */.ywL, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlinePlus */.Lfi, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "question text-[25px] md:text-[30px] mb-[20px] font-medium",
                        children: question
                    }),
                    blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "answer text-[16px] md:text-[18px] font-light text-gray-700",
                        children: answer
                    }) : ""
                ]
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_BlogCard = (BlogCard);

;// CONCATENATED MODULE: ./components/CalculatorBlogs/Blog.jsx



const Blog = (param)=>{
    let { heading , BlogData , width ="lg:w-[850px]"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-[100%] mx-auto md:w-[80%] ".concat(width),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-[25px] md:text-[40px] text-center font-bold mb-14 mx-auto",
                children: heading
            }),
            BlogData.map((blog)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CalculatorBlogs_BlogCard, {
                    question: blog.question,
                    answer: blog.answer
                }, blog.id);
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_Blog = (Blog);


/***/ }),

/***/ 3224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants_signature__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24599);





const PdfToolsLinks = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full flex flex-col justify-center items-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "text-center text-2xl md:text-4xl text-gray-800 mb-10",
                children: "Other PDF tools offered by BoloForms"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "max-w-[1280px] mx-auto flex justify-center items-center flex-wrap gap-4",
                children: _constants_signature__WEBPACK_IMPORTED_MODULE_4__/* .signatureTools.map */ .kn.map((tool, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: tool.url,
                        className: "w-[220px] h-[80px] bg-white border rounded-xl drop-shadow-md px-4 hover:shadow-xl transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-105 z-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full h-full grid place-items-center text-xl text-gray-600",
                            children: tool.title
                        })
                    }, index))
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PdfToolsLinks);


/***/ }),

/***/ 86318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8193);
/* harmony import */ var react_icons_bs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63750);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10447);






const SignaturePopup = (param)=>{
    let { onPopupClose , source =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "bg-gray-600/50 w-full h-full fixed z-[1000] left-0 top-0 p-4 flex justify-center items-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative rounded-xl bg-violet-500 w-fit mx-auto lg:w-[700px] md:h-[500px] lg:h-[400px] text-white flex flex-col justify-between gap-[50px] md:gap-[10px] p-[50px] px-[20px] lg:px-[50px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    onClick: ()=>onPopupClose(),
                    className: "border border-b-none border-violet-300 shadow-xl absolute top-[20px] right-[20px] hover:opacity-90 cursor-pointer grid place-items-center text-white font-bold text-[20px]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_4__/* .AiOutlineClose */ .oHP, {
                        className: "font-bold"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col gap-[15px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-[25px] font-semibold",
                            children: "Take Signatures inside Forms & PDFs!"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-[18px]",
                            children: "Get started for Free"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "",
                            children: [
                                "Integrated Signatures: Add digital signature fields to your forms for easy signing.",
                                "PDF Downloads: Download documents with signatures as PDF files.",
                                "Super easy and simple to use."
                            ].map((item, index)=>{
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex gap-[10px] text-white",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_4__/* .AiFillCheckCircle */ .mny, {
                                                className: "text-[20px]"
                                            })
                                        }),
                                        item
                                    ]
                                }, index);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        target: "_blank",
                        href: "https://signature.boloforms.com/login?from=".concat(source).concat((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_3__/* .createUTMQueryParams */ .T0)({
                            from: source
                        })),
                        className: "flex justify-between items-center gap-4 w-fit bg-white text-violet-600 text-[17px] md:text-[20px] px-[20px] py-[8px] md:px-[40px] md:py-[12px] rounded-full hover:opacity-80",
                        children: [
                            "Check out BoloForms ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_5__/* .BsArrowRight */ .lzl, {})
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SignaturePopup);


/***/ }),

/***/ 99538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89583);
/* harmony import */ var pdfjs_dist__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99299);
/* harmony import */ var pdfjs_dist__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pdfjs_dist__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8193);
/* harmony import */ var jszip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55733);
/* harmony import */ var jszip__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(jszip__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _signature_module_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10411);
/* harmony import */ var _signature_module_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_signature_module_css__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _components_CalculatorBlogs_Blog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56130);
/* harmony import */ var _components_SignaturePopup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86318);
/* harmony import */ var _components_PdfToolsLinks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3224);












pdfjs_dist__WEBPACK_IMPORTED_MODULE_3__.GlobalWorkerOptions.workerSrc = "//unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js";
const BlogData = [
    {
        id: 1,
        question: "What is PDF to PNG Tool?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "",
                children: "A PDF to PNG tool is a utility that enables you to convert PDF documents into PNG image files. It allows you to extract images from the PDF or save each page as a separate PNG image."
            })
        })
    },
    {
        id: 2,
        question: "How to Convert PDFs to PNGs Online?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "",
                children: "To convert PDFs to PNGs online, you need to upload the PDFs you want to convert. After uploading, the tool processes the PDF and generates PNG images for each page. You can then download the converted PNG files."
            })
        })
    },
    {
        id: 3,
        question: "How to Use the PDF to PNG Conversion Tool?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "",
                children: "Using the PDF to PNG conversion tool is easy. Upload your PDF file, and the tool will automatically extract images and convert each page to PNG format. You can then download the PNG images individually or as a single ZIP file."
            })
        })
    },
    {
        id: 4,
        question: "Are There Any Limitations on PDF Size or Number of Pages?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: "",
                children: [
                    "The tool typically supports PDFs of various sizes and page counts. However, very large PDFs might take longer to process. There are usually no strict limitations on the number of pages, but ",
                    "it's",
                    " ",
                    "recommended to check the specific ",
                    "tool's",
                    " guidelines for any restrictions."
                ]
            })
        })
    },
    {
        id: 5,
        question: "Is the PDF to PNG Conversion Process Secure?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: "",
                children: [
                    "Yes, reputable online PDF to PNG conversion tools prioritize user privacy and security. They use encryption protocols to ensure the safety of your files. However, ",
                    "it's",
                    " advisable to use trusted and well-known platforms to convert your sensitive documents."
                ]
            })
        })
    }
];
const PdfToPng = ()=>{
    const [pdf, setPdf] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [images, setImages] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [pageRendering, setPageRendering] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [loader, setLoader] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [pagesToDownload, setPagesToDownload] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [signaturePopup, setSignaturePopup] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const scrollToPreview = ()=>{
        const element = document.getElementById("preview-pdfs");
        if (element) {
            element.scrollIntoView({
                behavior: "smooth"
            });
        }
    };
    const handleDrop = (e)=>{
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        showPdf(file);
        scrollToPreview();
    };
    const handlePdfUpload = (e)=>{
        const file = e.target.files[0];
        showPdf(file);
        if (file) {
            scrollToPreview();
        }
    };
    const showPdf = async (file)=>{
        try {
            const uri = URL.createObjectURL(file);
            const _PDF_DOC = await (0,pdfjs_dist__WEBPACK_IMPORTED_MODULE_3__.getDocument)({
                url: uri
            }).promise;
            setPdf(_PDF_DOC);
            setPagesToDownload(Array.from({
                length: _PDF_DOC.numPages
            }, (_, i)=>i + 1));
        } catch (error) {
            alert(error.message);
        }
    };
    const renderPage = async ()=>{
        setPageRendering(true);
        const imagesList = [];
        for(let i = 1; i <= pdf.numPages; i++){
            const page = await pdf.getPage(i);
            const viewport = page.getViewport({
                scale: 1
            });
            const canvas = document.createElement("canvas");
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            const renderContext = canvas.getContext("2d");
            await page.render({
                canvasContext: renderContext,
                viewport: viewport
            }).promise;
            const img = canvas.toDataURL("image/png");
            imagesList.push(img);
        }
        setImages(imagesList);
        setPageRendering(false);
    };
    const downloadImages = ()=>{
        if (!images.length > 0) return;
        setLoader(true);
        const fileName = "pdf-to-png.zip";
        const zip = new (jszip__WEBPACK_IMPORTED_MODULE_4___default())();
        const imgFolder = zip.folder("images");
        for(let i = 0; i < images.length; i++){
            if (!pagesToDownload.includes(i + 1)) continue;
            const base64 = images[i].replace(/^data:image\/(png|jpg);base64,/, "");
            imgFolder.file("image-".concat(i + 1, ".png"), base64, {
                base64: true
            });
        }
        zip.generateAsync({
            type: "blob"
        }).then((content)=>{
            const url = window.URL.createObjectURL(content);
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        });
        setLoader(false);
        setTimeout(()=>{
            setSignaturePopup(true);
        }, 2000);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        pdf && renderPage();
    }, [
        pdf
    ]);
    const addOrRemovePage = (page)=>{
        if (pagesToDownload.includes(page)) {
            setPagesToDownload(pagesToDownload.filter((p)=>p !== page));
        } else {
            setPagesToDownload([
                ...pagesToDownload,
                page
            ]);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "w-full mt-20 sm:mt-24",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            charSet: "utf-8"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                            children: "PDF to PNG Tool | BoloForms"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "description",
                            content: "Convert PDF files to PNG images online for free. No software installation required."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "keywords",
                            content: "pdf to image, pdf to images, pdf to photo, pdf to image boloforms, pdf to png boloforms, pdf to png, pdf to png converter, convert pdf to png, pdf to png online, pdf to png free, pdf to png tool, pdf to png conversion, pdf to png converter online, pdf to png converter free, pdf to png converter tool"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "author",
                            content: "BoloForms"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "viewport",
                            content: "width=device-width, initial-scale=1.0"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                            rel: "canonical",
                            href: "https://www.bolosign.com/signature/pdf-tools/pdf-to-png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:title",
                            content: "PDF to PNG Tool | BoloForms"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:description",
                            content: "Convert PDF files to PNG images online for free. No software installation required."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:url",
                            content: "https://www.bolosign.com/signature/pdf-tools/pdf-to-png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:site_name",
                            content: "BoloForms"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:image:width",
                            content: "1200"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:image:height",
                            content: "630"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:image:alt",
                            content: "BoloForms"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:type",
                            content: "website"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:locale",
                            content: "en_US"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "twitter:card",
                            content: "summary_large_image"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "twitter:site",
                            content: "@BoloForms"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "twitter:creator",
                            content: "@BoloForms"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "twitter:title",
                            content: "PDF to PNG Tool | BoloForms"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "twitter:description",
                            content: "Convert PDF files to PNG images online for free. No software installation required."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                            rel: "canonical",
                            href: "https://www.bolosign.com/signature/pdf-tools/pdf-to-png/"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "max-w-[1280px] mx-auto px-2 md:px-10 py-20 rounded-xl relative flex flex-col gap-20",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "text-violet-500 text-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            className: "text-3xl md:text-6xl text-gray-800",
                                            children: "PDF to PNG Tool"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-lg md:text-2xl mt-4 text-gray-600",
                                            children: "Convert PDF files to PNG images online for free."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "extraOutline p-4 bg-white bg-whtie mx-auto rounded-lg w-full md:w-[600px]",
                                    onDragEnter: (e)=>e.preventDefault(),
                                    onDragOver: (e)=>e.preventDefault(),
                                    onDragLeave: (e)=>e.preventDefault(),
                                    onDrop: handleDrop,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "file_upload px-2 md:px-20 py-5 md:py-14 relative border-4 border-dotted border-gray-300 rounded-lg",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_8__/* .FaFileUpload */ .Gq2, {
                                                className: "text-gray-400 w-20 md:w-32 mx-auto mb-6 md:mb-10 text-[80px] md:text-[120px]"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "input_field flex flex-col w-full mx-auto text-center",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                onChange: handlePdfUpload,
                                                                className: "text-sm cursor-pointer w-36 hidden",
                                                                type: "file",
                                                                accept: ".pdf"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "text bg-violet-600 text-white text-xl border border-gray-300 rounded-xl font-semibold cursor-pointer py-3 md:py-4 hover:bg-indigo-500",
                                                                children: "Upload PDF File"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "title text-gray-500 uppercase text-lg md:text-xl",
                                                        children: "or drop file here"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            id: "preview-pdfs",
                            className: "max-w-[1280px] mx-auto flex flex-col gap-14 justify-center items-center",
                            children: [
                                pdf && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                            className: "text-3xl font-light text-center text-gray-700",
                                            children: [
                                                "Disselect Pages that you ",
                                                "don't",
                                                " want"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "relative w-full h-[400px] flex flex-wrap justify-center gap-4 border-2 md:px-10 py-4 md:py-14 md:rounded-xl overflow-y-scroll scrollbar-thin scrollbar-thumb-violet-500 scrollbar-rounded-[12px]",
                                            children: [
                                                images.map((image, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "border drop-shadow-2xl w-fit relative flex justify-center items-center flex-wrap",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "border-1 drop-shadow-lg p-4 bg-white w-[230px]",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    id: "image-generated",
                                                                    src: image,
                                                                    alt: "pdfImage",
                                                                    className: "w-[full"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "absolute top-2 left-2 w-8 h-8 bg-violet-500 rounded-full text-xl text-white flex justify-center items-center cursor-pointer",
                                                                children: index + 1
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                onClick: ()=>addOrRemovePage(index + 1),
                                                                className: "absolute top-2 right-2 w-8 h-8 ".concat(pagesToDownload.includes(index + 1) ? "bg-violet-500" : "bg-gray-400", " rounded-full text-xl text-white flex justify-center items-center cursor-pointer"),
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_9__/* .AiOutlineCheck */ .bzc, {})
                                                            })
                                                        ]
                                                    }, index)),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    id: "page-loader",
                                                    className: "".concat(pageRendering ? "absolute w-full top-0 left-0 h-full flex justify-center items-center bg-white z-50" : "hidden"),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                        "aria-hidden": "true",
                                                        class: "w-14 h-14 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-violet-600",
                                                        viewBox: "0 0 100 101",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                                                                fill: "currentColor"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                                                                fill: "currentFill"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                images.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    id: "split-pdfs",
                                    className: "w-full",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: downloadImages,
                                        className: "bg-violet-600 mx-auto w-full sm:w-[350px] py-4 text-xl rounded-lg font-semibold text-white flex items-center justify-center gap-4 hover:bg-violet-400",
                                        children: loader ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            class: "flex items-center text-white space-x-2 ".concat((_signature_module_css__WEBPACK_IMPORTED_MODULE_10___default().loader)),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    class: "",
                                                    children: "Downloading"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    class: "w-2 h-2 bg-white rounded-full animate-bounce"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    class: "w-2 h-2 bg-white rounded-full animate-bounce"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    class: "w-2 h-2 bg-white rounded-full animate-bounce"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                "Download Zip ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_8__/* .FaDownload */ .aBF, {
                                                    className: "text-3xl"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        signaturePopup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SignaturePopup__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            onPopupClose: ()=>setSignaturePopup(false),
                            source: "PDF_TO_PNG"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mt-20",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mb-20",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PdfToolsLinks__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CalculatorBlogs_Blog__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    heading: "PDF To PNG Tool FAQs",
                                    BlogData: BlogData
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PdfToPng);


/***/ }),

/***/ 10411:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"signatureFont":"signature_signatureFont__RxQpu","signatureShadow":"signature_signatureShadow__hfutn","headingAnimation":"signature_headingAnimation___OGQQ","changeImageAnimation":"signature_changeImageAnimation__xeM9_","moveLineAnimation":"signature_moveLineAnimation__uc0qS","changeHeightAnimation":"signature_changeHeightAnimation__AjMNd","rotateIconsAnimation":"signature_rotateIconsAnimation__pFB1R","moveStepsLineAnimation":"signature_moveStepsLineAnimation__MUlje","moveTextUpAnimation":"signature_moveTextUpAnimation__Y6QVi","scrollImageAnimation":"signature_scrollImageAnimation___7bVj","scrollImageAnimationMobile":"signature_scrollImageAnimationMobile__pGKm5","stepsImage":"signature_stepsImage__zJWMg","countryImage":"signature_countryImage__wMRyn","imagePosition":"signature_imagePosition__iJEJi","legalImages":"signature_legalImages__3yVVS","loader":"signature_loader__Zqlyl","topBg":"signature_topBg__j0SDC"};

/***/ }),

/***/ 93414:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 70172:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 2001:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 33779:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 82258:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2013,4617,4577,2749,4599,9774,2888,179], function() { return __webpack_exec__(54286); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);